import deepmerge from 'deepmerge'


const overwriteMerge = (destinationArray, sourceArray, options) => {
  return sourceArray
}

export default class Reducer {
  constructor () {
    this._items = {}
  }

  register (action, mergeFunc) {
    this._items[action] = mergeFunc
  }

  build () {
    return (state = {}, action) => {
      const mergeFunc = this._items[action.type]
      if (mergeFunc) {
        const changes = mergeFunc(action)
        const copy = Object.assign({}, state)
        return deepmerge(copy, changes, { arrayMerge: overwriteMerge })
      } else {
        return state
      }
    }
  }
}
